import styled from 'styled-components';

export const ApplicationPageContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 25px;
`;
